export default __webpack_public_path__ + "static/media/Shoulder_Pain.21831a55.png";